export const BRAND = {
  name: "LF TEAM",
  tagline: "Consultoria Premium",
};

// TODO: troque pelo número real (código do país + DDD + número, só dígitos)
export const WHATSAPP_NUMBER = "554799127480";

export const DEFAULT_WA_MESSAGE = "Olá tudo bem? Quero entender mais sobre a consultoria";

export const waLink = (text = DEFAULT_WA_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const INSTAGRAM_URL = "https://www.instagram.com/lucasfucht/";
export const INSTAGRAM_HANDLE = "@lucasfucht";

// Vagas do mês exibidas na barra de urgência do topo
export const VAGAS_RESTANTES = 3;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "/hero-lf2.jpg",
  training:
    "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85",
  nutrition:
    "https://images.unsplash.com/photo-1606791422814-b32c705e3e2f?crop=entropy&cs=srgb&fm=jpg&q=85",
  portrait:
    "https://images.unsplash.com/photo-1623950851918-116ba38150d2?crop=entropy&cs=srgb&fm=jpg&q=85",
};
